// extracted by mini-css-extract-plugin
export default {"normal":"Answer_normal__D53tX","shake":"Answer_shake__VeILt","fadeAnswer":"Answer_fadeAnswer__1DBzI","fadeOut":"Answer_fadeOut__HDghE"};